import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IReelStartSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {TombOfAkhenaten} from "../TombOfAkhenaten";
import {TOATimelineReelsController} from "./TOATimelineReelsController";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {TombOfAkhenatenReelAreaView} from "./TombOfAkhenatenReelAreaView";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";

export class TombOfAkhenatenReelController extends SpinReelController {

    private _mask: PIXI.Sprite | PIXI.Graphics;
    private _scatterPositions: number[] = [];
    public static SCATTER_COUNT: number = 0;
    private static _reelsActualSpinningStates: boolean[];
    private static isFinalReSpin: boolean = false;
    public _x2OnWild: PIXI.Sprite | null = null;
    private static nearWinDelayCounter: number = 0;
    private _firstBlurSym: boolean = false;
    private _shouldHandleExtendedSym : boolean = false;

    protected addEventListeners() {
        super.addEventListeners();
        TombOfAkhenatenReelController._reelsActualSpinningStates = ArrayHelper.initArrayWithValues(TombOfAkhenatenGameConfig.instance.REELS_NUM, function () {
            return false;
        });
        EventHandler.addEventListener(this, TOAGameEvent.ON_NEW_GAME_ROUND, () => this.onNewGameRound());
        EventHandler.addEventListener(this, TOAGameEvent.ON_GAME_START, () => this.onGameStart());
    }

    public startSpin(data: IReelStartSpinData, previousDelay: number): number {
        this._firstBlurSym = false;
        TombOfAkhenatenReelController._reelsActualSpinningStates[this.reelId] = false;
        if(!this.isExtendedSym(this.allSymbols[0].symName) || !(<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController).is5x3Reel){
            this._shouldHandleExtendedSym = false;
            this._mask.height = TombOfAkhenatenReelAreaView.maskHeightMap.get(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) || 188;
            this._mask.y = 0;
            this._mask.width = TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH;
            if ((TombOfAkhenaten.timelineReelsController as TOATimelineReelsController)._stickySymArr[this._reelId] && this.isExtendedSym(this.allSymbols[0].symName)) {
                this.animateSymHeight(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);
            } else {
                (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController)._isNextFinalSpin && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_REEL_VIEW_BY_REEL_ID, this._reelId, TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN))
            }
        }else{
            this._shouldHandleExtendedSym = true;
        }
        // this._mask.height = TombOfAkhenatenReelAreaView.maskHeightMap.get(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) || 188;
        // this._mask.y = 0;`
        // this._mask.width = TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH;
        // if ((TombOfAkhenaten.timelineReelsController as TOATimelineReelsController)._stickySymArr[this._reelId] && this.isExtendedSym(this.allSymbols[0].symName)) {
        //     this.animateSymHeight(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);
        // } else {
        //     (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController)._isNextFinalSpin && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_REEL_VIEW_BY_REEL_ID, this._reelId, TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN))
        // }
        return super.startSpin(data, previousDelay);
    }

    private onNewGameRound() {
        TombOfAkhenatenReelController.nearWinDelayCounter = 0;
        TombOfAkhenatenReelController.SCATTER_COUNT = 0;
        this._x2OnWild = null;
    }

    // updating GameData for fixing #17
    public updateGameData(data: ParsedGameData): void {
        this._gameMode = data.mode;
        this._nextGameMode = data.nextMode;
        this._stopReelSet = data.reels[this._reelId];
        TombOfAkhenatenReelController.isFinalReSpin = data.mode.indexOf("FINAL") > -1;

    }

    public reOrderSymbols(isCalledFromReplaceWild: boolean = false) {
        if (this._reelInitialized) {
            let gameConfig = TombOfAkhenatenGameConfig.instance,
                viewPosY: number = this.view.position.y;

            //this.toggleTopAndBottomSymbol(false);
            this.animateSymHeight(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);

            if (this.isExtendedSym(this.allSymbols[0].symName)) {
                if (gameConfig.REELS_ON_TOP.indexOf(this.reelId) === -1) {
                    gameConfig.REELS_ON_TOP.push(this.reelId);
                }
                this.view.parent.addChild(this.view);
                !isCalledFromReplaceWild && (this.view.position.y = viewPosY - 4);
            }
        }
    }

    public animateSymHeight(rowCount: number): void {
        let gameConfig = TombOfAkhenatenGameConfig.instance,
            symHeight: number = (gameConfig.REEL_AREA_HEIGHT / rowCount) - 10,
            //symHeight: number = ((584) - (10 * (rowCount - 1))) / rowCount,
            symWidth: number = TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH,
            maskNewHeight: number = TombOfAkhenatenReelAreaView.maskHeightMap.get(rowCount) || 188;//symHeight;

        if (this.isExtendedSym(this.allSymbols[0].symName)) {
            maskNewHeight = symHeight + (TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT);
            TweenLite.to(this._mask, 0, {
                y: -((TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT) / 2),
                width: symWidth + 16
            });
        } else {
            //maskNewHeight = symHeight;
            TweenLite.to(this._mask, 0, {
                y: 0,
                width: symWidth
            });
        }

        TweenLite.to(this._mask, 0, {
            height: maskNewHeight
        });

    }

    protected onSpinStopStarted(): void {
        super.onSpinStopStarted();
        this.reOrderSymbols();
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.BONUS_WIN_NOWIN, this.reelId));
        const symbolName = this.allSymbols[0].symName;
        if (symbolName === "S") {
            TombOfAkhenatenReelController.SCATTER_COUNT++;
            if (this.isFreeSpin()) {
                //EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.SHOW_AWARDED_AKHENATEN_SPINS, "+" + this.getAwardedSpins()));
            } else {
                TombOfAkhenatenReelController.SCATTER_COUNT > 2 && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.SHOW_AWARDED_AKHENATEN_SPINS, this.getAwardedSpins().toString()));
            }
        }
        //to land with win or dim in final respin
        if (TombOfAkhenatenReelController.isFinalReSpin) {
            if (symbolName == "W2" && (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController).reelWinPositions[this._reelId]) {
                //Handle landing W2 case here
                if (TombOfAkhenatenReelController.SCATTER_COUNT < 2) {
                    const sym = this.allSymbols[0];
                    sym.changeState({
                        state: TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal,
                        fadeInDuration: 0
                    })
                    //Logger.logDev("StateChangeOnLand Highlight W2 reelID is :: " + this._reelId);
                } else {
                    //Logger.logDev("StateChangeOnLand should semiDimmed W2 reelID is :: " + this._reelId);
                }
            } else if ((TombOfAkhenaten.timelineReelsController as TOATimelineReelsController).isHighlightWinSymOnLandForFinalSpin[this._reelId] &&
                (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController).reelWinPositions[this._reelId]) {
                //Logger.logDev("StateChangeOnLand Highlight reelID is :: " + this._reelId);
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ADD_SYM_STATE_FIRE, this._reelId, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword));
            } else {
                //Logger.logDev("StateChangeOnLand dim reelID is :: " + this._reelId);
                const sym = this.allSymbols[0];
                sym.changeState({
                    state: TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin,
                    fadeInDuration: 0
                })
            }
        }
    }

    protected createReelView(): PIXI.Container {
        const reelView: PIXI.Sprite = new PIXI.Sprite(),
            maskShape: PIXI.Graphics = new PIXI.Graphics(),
            symHeight: number = (TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) - 10,
            offset = 0;

        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(-TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH / 2, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH, symHeight);
        maskShape.endFill();

        if (this._mask != null) {
            reelView.removeChild(this._mask);
        }

        maskShape.y -= offset;
        maskShape.height += offset;

        this._mask = maskShape;
        this._mask.name = "reelMask_" + this.reelId;

        reelView.addChild(this._mask);
        reelView.mask = this._mask;
        return reelView;
    }

    protected startSpinAnimation(data: IReelStartSpinData, previousDelay: number): number {
        //this.toggleTopAndBottomSymbol(true);
        return super.startSpinAnimation(data, previousDelay);
    }

    protected completeSpin() {
        //Logger.logDev("completeSpin for reelId : " + this._reelId);
        TombOfAkhenatenReelController._reelsActualSpinningStates[this.reelId] = true;
        //Logger.logDev("reelsPos for reelId : " + this.reelId + " pos is " + this.allSymbols[0].parent.position.y);
        super.completeSpin();
        if (!TombOfAkhenatenReelController._reelsActualSpinningStates.includes(false)) {
            //Logger.logDev("---------completeSpin ALL_SPIN_STOP_COMPLETE : -------");

            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ALL_SPIN_STOP_COMPLETE, this.reelId));
        }
    }

    protected parseInitData(data: TombOfAkhenatenParsedInitData) {
        super.parseInitData(data);
        if (data.reels[this.reelId][0] === "S") {
            this._scatterPositions.push(this.reelId);
            if (this.reelId % 5 >= (5 - data.activeRows)) {
                TombOfAkhenatenReelController.SCATTER_COUNT++;
            }
        }
    }

    // to hide the first & last symbol in reel for displaying overlapping symbol.
    protected initReelStrip(): void {
        super.initReelStrip();

        if (this._reelInitialized) {
            this.view.name = this.reelId.toString();
            this.reOrderSymbols();
        }
    }

    protected getNearWinStopDelay(reelId: number): number {
        let delay: number = super.getNearWinStopDelay(reelId);
        TombOfAkhenatenReelController.nearWinDelayCounter++;
        let decelerateDelay: number = delay / 20;
        const finalDelay = Math.max(delay - (decelerateDelay * TombOfAkhenatenReelController.nearWinDelayCounter), delay * 0.5);
        //Logger.logDev("getNearWinStopDelay delay : " + delay + " - decelerateDelay : " + decelerateDelay + " final delay = " + finalDelay);
        return finalDelay;
    }

    protected onSpinStartedCompleted() {
        if(this._shouldHandleExtendedSym){
            this._mask.height = TombOfAkhenatenReelAreaView.maskHeightMap.get(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) || 188;
            this._mask.y = 0;
            this._mask.width = TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH;
            if ((TombOfAkhenaten.timelineReelsController as TOATimelineReelsController)._stickySymArr[this._reelId] && this._shouldHandleExtendedSym) {
                 this.animateSymHeight(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);
            } else {
                (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController)._isNextFinalSpin && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_REEL_VIEW_BY_REEL_ID, this._reelId, TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN))
            }
        }
        super.onSpinStartedCompleted()
    }

    protected onSpinStopAnimationCompleted() {
        let symbolName = this.allSymbols[0].symName;
        if (symbolName === "S") {
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PLAY_BONUS_SPINE, this.reelId, "bonusLanding"));
            if (this.isFreeSpin()) {
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.SHOW_AWARDED_SPINS, "+" + this.getAwardedSpins(), this._reelId));
            }
        }
        if (symbolName === "W") {
            if (TombOfAkhenatenReelController.isFinalReSpin) {
                const isParticipatingOnWin: boolean = (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController).isHighlightWinSymOnLandForFinalSpin[this._reelId] &&
                    (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController).reelWinPositions[this._reelId];
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PLAY_WILD_LANDING, this.reelId, isParticipatingOnWin));
            } else {
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PLAY_WILD_LANDING, this.reelId, true));
            }
        }

        // if (symbolName == "W2") {
        //     EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.STOP_PYRAMID_WILD_ANTICIPATION, Math.floor(this._reelId / 5)));
        // }
        super.onSpinStopAnimationCompleted();
    }


    private getAwardedSpins(): number {
        if (this.isFreeSpin()) {
            return 1;
        }
        return (TombOfAkhenatenReelController.SCATTER_COUNT - 3) * 2 + 8;
    }

    private isFreeSpin(): boolean {
        return this._gameMode == TombOfAkhenatenGameMode.FREESPIN || this._gameMode == TombOfAkhenatenGameMode.FS_RESPIN_FIRST ||
            this._gameMode == TombOfAkhenatenGameMode.FS_RESPIN_SECOND || this._gameMode == TombOfAkhenatenGameMode.FS_RESPIN_FINAL;
    }

    /**
     * #101
     * @override for quick spin delay
     * @param reelId
     * @protected
     */
    protected getFastSpinStopDelay(reelId: number): number {
        return TombOfAkhenatenGameConfig.instance.REEL_FAST_SPIN_DELAY;
    }

    protected getNormalStopDelay(reelId: number): number {
        return super.getNormalStopDelay(reelId);
    }

    hasNearWin(reelId?: number): boolean {
        reelId = reelId ?? this.reelId;
        const nearWinReels = (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController).nearWinReels;
        const isNearWin = (nearWinReels != null && nearWinReels[reelId]) || (this._nearWinBigWinReels != null && this._nearWinBigWinReels[reelId]);
        return isNearWin;
    }

    protected addNewSymbol(symName: string, state?: ISymbolStateConfig): StateReelSymbol {
        if (state == null) {
            state = this._isSpinBlurred ? TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.spin : TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal;
        }
        let symbol = this._reelPartCreator.createNewSymbol(symName, this._reelId, state, {
            width: this._reelPartAnimator.symWidth,
            height: this._reelPartAnimator.symHeight,
            bottomPadding: this._reelPartAnimator.symBottomPadding
        });
        symbol.x = 0;
        symbol.y = -symbol.symHeight / 2 - TombOfAkhenatenGameConfig.instance.REEL_AREA_POS_Y - TombOfAkhenatenGameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId][1];
        // this is just a temp position that's not visible. this position might be visible in portrait mode but it doesn't matter. the position will be updated when put the symbol to the animator.
        //const sym = this.allSymbols && this.allSymbols[0];
        if (!this._firstBlurSym && this._shouldHandleExtendedSym) {
            //Logger.logDev("addNewSymbol first sym : ", this._reelId);
            this._firstBlurSym = true;
            symbol.alpha = 0.2;
            this._reelView.addChildAt(symbol, 0);
        } else {
            this._reelView.addChild(symbol);
        }
           // this._reelView.addChild(symbol);

        return symbol;
    }

    // #417 -> after changed reel spin feel, to fix blur visible on spin start
    protected createNextSymbol(previousSymbol?: StateReelSymbol | null, init?: boolean): StateReelSymbol {
        const retVal: StateReelSymbol = super.createNextSymbol(previousSymbol, init);
        if (this._currentState === ReelAnimationState.START_SPIN) {
            retVal.setVisibility(false);
        }
        return retVal;
    }

    setFakeReel() {
        this._currentReelSet = this.makeUpStopReelSet(GameConfig.instance.SYMBOLS_NUM_IN_REEL[4], true);
        this._currentReelSet = this._currentReelSet.filter((symName)=>{
            return symName != "S";
        });
        this._currentReelSetPosition = Math.floor(this._currentReelSet.length / 2);
        const stopSymbols: (StateReelSymbol | null)[] = [];
        for (let i: number = 0; i < this._symNumTotal; i++) {
            stopSymbols.unshift(this.createNextSymbol(i === 0 ? null : stopSymbols[0], false));
        }
        const reelSym = this.allSymbols.pop();
        if (reelSym) {
            reelSym.visible = false;
            this._reelPartAnimator.initSymbols(stopSymbols.map(s => s!));
            this.removedChildOnView(reelSym);
            this.reOrderSymbols();
        }
    }

    //413
    private onGameStart(): void{
        if(this._scatterPositions && this._scatterPositions.length > 0 && !(TombOfAkhenatenGameConfig.instance.GAME_RESTORED)){
            let viewPosY: number = this.view.position.y;
            this.view.position.y = viewPosY - 4;
        }
    }

    private isExtendedSym(symbolName: string): boolean {
        return (TombOfAkhenatenGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(symbolName) > -1);
    }
}